import { createSlice } from '@reduxjs/toolkit'

interface toasterProps {
  id?: number,
  type?: string,
  title?: string,
  message?: any,
  closeButton?: boolean,
  timestamp?: number
}

interface initialStateInt {
  toaster: toasterProps[]
}

// initial state
const initialState: initialStateInt = {
  toaster: []
};

let nextToastId = 0;

export const toasterSlice = createSlice({
  name: 'toaster',
  initialState,
  reducers: {
    toasterAlert: (state, { payload }) => {
      const newPayload = Object.assign({}, payload);
      newPayload.id = ++nextToastId;
      newPayload.timestamp = Date.now();
      state.toaster = [...state.toaster, newPayload]
    },
    toasterRemove: (state, { payload }) => {
      const index = state.toaster.findIndex((arrow: any) => arrow.id === payload);
      if (index !== -1) {
        state.toaster.splice(index, 1);
      }
    }
  }
})

export const { toasterAlert, toasterRemove } = toasterSlice.actions

export default toasterSlice.reducer
